import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    this.scrollContainer = this.element.closest('.main') || window
    this.sections = [...document.querySelectorAll('.event-summary-navigation-target')]
    this.scrollSpacer = document.createElement('div')
    this.scrollSpacer.classList.add('event-summary-navigation-spacer', 'print-hidden')
    this.scrollSpacer.setAttribute('aria-hidden', 'true')
    this.sections[this.sections.length - 1]?.insertAdjacentElement('afterend', this.scrollSpacer)
  }

  disconnect () {
    this.scrollSpacer.remove()
  }

  navigate (event) {
    const section = document.getElementById(event.currentTarget.value)

    if (!section) return

    const scrollMargin = parseFloat(window.getComputedStyle(section).scrollMarginTop) || 0
    const containerTop = this.scrollContainer === window
      ? 0
      : this.scrollContainer.getBoundingClientRect().top

    this.scrollSpacer.style.height = '0'

    const currentScrollTop = this.scrollContainer === window
      ? window.scrollY
      : this.scrollContainer.scrollTop

    const sectionTop = currentScrollTop +
      section.getBoundingClientRect().top -
      containerTop -
      scrollMargin

    const scrollElement = this.scrollContainer === window
      ? document.documentElement
      : this.scrollContainer
    const maximumScrollTop = scrollElement.scrollHeight - scrollElement.clientHeight
    const missingSpace = Math.max(0, Math.ceil(sectionTop - maximumScrollTop))

    this.scrollSpacer.style.height = `${missingSpace}px`

    this.scrollContainer.scrollTo({
      top: sectionTop,
      behavior: 'auto'
    })

    event.currentTarget.value = ''
  }
}
